const addUser = (userObj) => {
    return {
        type: "ADDUSER",
        payload: userObj
    }
}

export default { addUser }